import LandmarksAPI from '../api/landmarksid';
import {all, call, takeLatest, put} from 'redux-saga/effects'

import {
  SAGA_COMMON_LOAD_ORGANIZATIONS,
  setOrganizations,
  setCategories,
  SAGA_COMMON_LOAD_CATEGORIES,
}from './actions';

// Get organizations from the server
function* getOrganizations() {
  const results = yield call(LandmarksAPI.getOrganizations);

  // Error checking the server response
  if (results.error === null){
    yield put(setOrganizations(results.json.body));
  } else {
    yield put({type: 'ERROR_IN_FETCHING_DATA'});
  }
}

function* getCategories() {
  const results = yield call(LandmarksAPI.getCategories);

  if (results.error === null){
    yield put(setCategories(results.json.body));
  } else {
    yield put({type: 'ERROR_IN_FETCHING_DATA'});
  }
}

// Server functions

export default function* commonSaga(){
	yield all([
    takeLatest(SAGA_COMMON_LOAD_ORGANIZATIONS, getOrganizations),
    takeLatest(SAGA_COMMON_LOAD_CATEGORIES, getCategories),
	]);
}


// WEBPACK FOOTER //
// ./src/shared/sagas.js